import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { URL_SERVER } from '../utils/Utils';

const usePasswordChange = () => {
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  // 🔥 TOKEN DESDE LOCALSTORAGE (NO DESDE URL)
  const token = localStorage.getItem('reset_token');

  const handlePasswordChange = async () => {
    console.log("TOKEN ENVIADO:", token); // 🔥 DEBUG

    if (!token) {
      alert("Token inválido");
      return;
    }

    if (!newPassword) {
      alert("Introduce una contraseña");
      return;
    }

    try {
      await axios.post(`${URL_SERVER}/reset-password`, {
        token: token,
        password: newPassword,
      });

      alert("Contraseña cambiada correctamente");

      // limpiar token
      localStorage.removeItem('reset_token');

      navigate('/');

    } catch (error) {
      console.error(error);
      alert("Error al cambiar contraseña");
    }
  };

  return {
    newPassword,
    setNewPassword,
    handlePasswordChange
  };
};

export default usePasswordChange;